var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1634 21.8367C12.7156 21.8367 13.1634 21.3889 13.1634 20.8367C13.1634 20.2844 12.7156 19.8367 12.1634 19.8367C11.6111 19.8367 11.1634 20.2844 11.1634 20.8367C11.1634 21.3889 11.6111 21.8367 12.1634 21.8367Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6634 3.83666C10.3872 3.83666 10.1634 4.06052 10.1634 4.33666C10.1634 4.6128 10.3872 4.83666 10.6634 4.83666H13.6634C13.9395 4.83666 14.1634 4.6128 14.1634 4.33666C14.1634 4.06052 13.9395 3.83666 13.6634 3.83666H10.6634Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.16336 2.83666C5.16336 2.28438 5.61108 1.83666 6.16336 1.83666H18.1634C18.7156 1.83666 19.1634 2.28438 19.1634 2.83666V22.8367C19.1634 23.3889 18.7156 23.8367 18.1634 23.8367H6.16336C5.61108 23.8367 5.16336 23.3889 5.16336 22.8367V2.83666ZM6.16336 2.83666V22.8367H18.1634V2.83666H6.16336Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/Mobile.c74b5d34349ee590699da41af88a6868.svg";
export { ForwardRef as ReactComponent };